import { useState } from 'react'
import { Link } from 'react-router-dom'

import { useForgotPassword } from '../../hooks/queries'

/**
 * Passwort vergessen -- Schritt eins.
 *
 * Nach dem Abschicken steht hier immer derselbe Satz, auch wenn es die
 * Adresse gar nicht gibt. Alles andere machte das Formular zu einem
 * Verzeichnis: wer eine Adresse durchprobiert, wüsste sonst, wer mitliest.
 */
export function ForgotPage() {
  const forgot = useForgotPassword()
  const [email, setEmail] = useState('')

  if (forgot.isSuccess) {
    return (
      <div className="centered">
        <div className="card">
          <h1>Sieh in dein Postfach</h1>
          <p className="card__lead">
            Wenn es zu <strong>{email}</strong> ein Konto gibt, ist eine
            Nachricht mit einem Link unterwegs. Er gilt eine Stunde und lässt
            sich einmal verwenden.
          </p>
          <p style={{ fontSize: 14, color: 'var(--text-muted)' }}>
            Nichts angekommen? Sieh im Spam-Ordner nach, und prüfe die
            Schreibweise der Adresse.
          </p>
          <Link className="button button--outline" to="/login">
            Zurück zur Anmeldung
          </Link>
        </div>
      </div>
    )
  }

  return (
    <div className="centered">
      <form
        className="card"
        onSubmit={(event) => {
          event.preventDefault()
          forgot.mutate(email)
        }}
      >
        <h1>Passwort vergessen</h1>
        <p className="card__lead">
          Trag deine E-Mail-Adresse ein. Wir schicken dir einen Link, über den
          du ein neues Passwort vergibst.
        </p>

        {forgot.isError && <p className="notice">{forgot.error.message}</p>}

        <label className="field">
          <span className="field__label">E-Mail-Adresse</span>
          <input
            className="field__input"
            type="email"
            autoComplete="username"
            required
            autoFocus
            value={email}
            onChange={(event) => setEmail(event.target.value)}
          />
        </label>

        <button className="button" type="submit" disabled={forgot.isPending}>
          {forgot.isPending ? 'Einen Moment …' : 'Link anfordern'}
        </button>

        <p style={{ marginTop: 18, textAlign: 'center', fontSize: 14 }}>
          <Link to="/login">Zurück zur Anmeldung</Link>
        </p>
      </form>
    </div>
  )
}
